export function disableScroll() {
  if (isScrollDisabled()) return;
  document.documentElement.style.overflow = 'hidden';
  // We need relative positioning support IOS Safari devices which ignore overflow:hidden alone on body
  document.body.style.position = 'relative';
}

export function enableScroll() {
  if (!isScrollDisabled()) return;
  document.documentElement.style.overflow = 'unset';
  document.body.style.position = '';
}

export function isScrollDisabled() {
  return document.documentElement.style.overflow === 'hidden';
}

export const scrollToTop = () => {
  window && window.scroll({ top: 0 });
};

export const restoreScrollPosition = (url: string) => {
  sessionStorage.setItem(`scrollPos:${url}`, JSON.stringify({ x: 0, y: 0 }));
};

export const scrollElementIntoView = ({
  element,
  shouldFocus = true,
  scrollIntoViewOptions,
}: {
  element: HTMLElement;
  shouldFocus?: boolean;
  scrollIntoViewOptions?: ScrollIntoViewOptions;
}) => {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  );
  const behavior = prefersReducedMotion.matches ? 'auto' : 'smooth';
  element.scrollIntoView({ behavior, ...scrollIntoViewOptions });
  if (shouldFocus) {
    element.focus({ preventScroll: true });
  }
};
